import React from 'react'
import SupportAgentIcon from '@mui/icons-material/SupportAgent'
import { Grid, Typography, Button } from '@mui/material'
import Pido from '../../assets/images/logo.png'
import useStyles from './styles'

function RightContent() {
    const classes = useStyles()

    return (
        <React.Fragment>
            <Grid className={classes.rightGrid}>
                <Typography fontSize={20} fontWeight="bold">
                    رسید دریافت سوخت از پیدو
                </Typography>
                <Typography fontSize={16} style={{ marginBottom: 30 }}>
                    امیدراویم سوخت گیری خوبی را با پیدو تجربه کرده باشید.
                </Typography>
                <img src={Pido} alt={"pido"} style={{ marginBottom: 10,borderRadius : '50%'  ,maxHeight : 80}} />
                <Typography fontSize={14} style={{ marginBottom: 10 }}>
                    در صورتی که به مشکلی برخوردید لطفا با پشتیبانی تماس بگیرید:
                </Typography>
                <Button
                    endIcon={<SupportAgentIcon />}
                    style={{ marginBottom: 50 }}
                    variant="outlined"
                    href='tel:02191076222'
                    color="inherit"
                >
                    {"تماس با پشتیبانی"}
                </Button>
                <Typography>
                    حق کپی برای پیدو محفوظ است.
                </Typography>
            </Grid>
        </React.Fragment >
    )
}

export default RightContent
